export function formatBackDate(date) {
  const newDate = new Date(date);

  const year = newDate.getFullYear();
  const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
  const day = newDate.getDate().toString().padStart(2, "0");
  const hours = newDate.getHours().toString().padStart(2, "0");
  const minutes = newDate.getMinutes().toString().padStart(2, "0");
  const seconds = newDate.getSeconds().toString().padStart(2, "0");

  // Obtém os milissegundos e garante que tenha 3 casas
  const milliseconds = newDate.getMilliseconds().toString().padStart(3, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export function formatMilliseconds(dateString) {
  if (!dateString) {
    return dateString;
  }
  if (!dateString.includes(".")) {
    return `${dateString}.000`;
  }
  const [base, ms = ""] = dateString.split(".");
  const formattedMs = ms.padEnd(3, "0").slice(0, 3);
  return `${base}.${formattedMs}`;
}
